import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import qs from 'query-string';
import Api from '../utils/Api';
import "../style/Login.css";

import logo from '../assets/ranky-logo-text-blue-gradient.png';

// ResetPassword Component
class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      passwordConfirmation: '',
      errorAlert: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePasswordError = this.handlePasswordError.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  submit(e) {
    e.preventDefault();
    const code = qs.parse(this.props.location.search).code;

    if (code) {
      Api.newPassword(this.state.username, code, this.state.password)
      .then(res => {
        this.setState({ username : '', password: '', passwordConfirmation: '', success : true, errorAlert : null});
      }).catch(err => {
        this.handlePasswordError(err.response.body);
      });
    }
  }

  handlePasswordError(err) {
    let text = '';
    if (err.code === "NotAuthorizedException")
        text = 'Votre ancien mot de passe n\'est pas valide';
    else if (err.code === "LimitExceededException")
        text = 'Trop de tentatives échouées. Merci de réessayer plus tard';
    else if (err.code === "ExpiredCodeException")
        text = 'Le mail que vous avez reçu a expiré. Merci de redemander un nouveau mail via le formulaire de mot de passe oublié.';
    else if (err.code === "InvalidPasswordException" || err.code === "InvalidParameterException")
        text = 'Votre nouveau mot de passe n\'est pas conforme, il doit faire au moins 8 caractères et comporter au moins un chiffre, une lettre minuscule et une lettre majuscule.';
    else
        text = 'Une erreur s\'est produite merci de nous contacter';
    
    const errorAlert = (<div className="alert alert-warning">
        {text}
    </div>);
    this.setState({ errorAlert, password : '', passwordConfirmation: '' });
}


  render() {
    const successAlert = (
      <div className="alert alert-success">
        Votre mot de passe a été réinitialisé.
        <Link to="/login">Cliquez ici</Link> pour vous connecter.
      </div>
    );

    return(
        <div className="login-wrapper">
          <div className="login-box card">
            <div className="logo-wrapper">
              <img className="logo" src={logo} alt="Ranky logo"/>
            </div>
            <form onSubmit={this.submit}>
              <div className="form-group">
                <label htmlFor="email">
                  <i className="pe-7s-mail gradient-icon-blue"></i>
                  Votre Adresse e-mail
                </label>
                <input value={this.state.username} onChange={this.handleInputChange} type="email" className="form-control" name="username" id="email" aria-describedby="email" required/>
              </div>
              <div className="form-group">
                  <label htmlFor="password">
                    <i className="pe-7s-key gradient-icon-blue"></i>
                    Votre nouveau mot de passe :
                  </label>
                  <input value={this.state.password} type="password" onChange={this.handleInputChange} className="form-control" id="password" name="password"/>
              </div>
              <div className="form-group">
                  <label htmlFor="password">
                    <i className="pe-7s-key gradient-icon-blue"></i>
                    Votre nouveau mot de passe :
                  </label>
                  <input value={this.state.passwordConfirmation} type="password" onChange={this.handleInputChange} className="form-control" id="passwordConfirmation" name="passwordConfirmation"/>
              </div>
              <hr/>
              { this.state.success && successAlert }
              { this.state.errorAlert || null }
              <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={
                !(this.state.username.length && this.state.password.length && this.state.passwordConfirmation.length) || !(this.state.password === this.state.passwordConfirmation)}>
                <i className="pe-7s-check gradient-icon-green-blue"></i>
                Valider
              </button>
            </form>
          </div>
        </div>
    );
  }
}
export default ResetPassword;



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js